




















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DecisionSLR, SLR, SLRStatus} from "@/components/payroll/sickLeave/slr/SLR_DTO";
import {prettyEnum} from "../../../../utils/StringUtils";
import moment, {Moment} from "moment-timezone";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";

@Component({
	components: {SingleFileHolder},
	methods: {
		moment(inp?: moment.MomentInput, format?: moment.MomentFormatSpecification, language?: string, strict?: boolean): Moment {
			return moment(inp, format, language, strict)
		},
		prettyEnum
	},
	computed: {
		SLRStatus() {
			return SLRStatus
		}
	}
})
export default class SLRData extends Vue {

	@Prop()
	private slr!: SLR

	resolveColor(): string {
		switch (this.slr.status) {
			case SLRStatus.COMPLETED:return "#3ECB7F"
			case SLRStatus.REQUESTED:return "#FEDC00"
			default: return "#818181"
		}
	}

}
